enum ForecasterDateRange {
  Day = 1,
  Week = 7,
  Month = 30,
}

export default ForecasterDateRange;
